import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Button, Card, Page, DisplayText } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json';
const propTypes = {
  orders_24_0h: PropTypes.number,
  orders_48_24h: PropTypes.number,
  orders_72_48h: PropTypes.number,
  orders_96_72h: PropTypes.number,
  orders_fulfilled: PropTypes.number,
}

const defaultProps = {

}

const OrdersCounter = (props) => {
  return (
    <AppProvider i18n={translations}>
      <Page
        title="Contador de Ordenes"
        fullWidth
      >
        <Card sectioned>
          <div className="orders-counter-container">
            <div className="flex flexColumn alignItemsCenter mb40">
              <div className="mb25">
                <DisplayText size="medium">
                  EMPACADAS HOY                
                </DisplayText>
              </div>
              <DisplayText size="extraLarge">
                { props.orders_fulfilled }                
              </DisplayText>
            </div>
  
            <div className="flex">
              <OrderCount
                title="0 A 24 HORAS"
                count={ props.orders_24_0h }
              />
              <OrderCount
                title="24 A 48 HORAS"
                count={ props.orders_48_24h }
              />
              <OrderCount
                warning
                title="48 A 72 HORAS"
                count={ props.orders_72_48h }
              />
              <OrderCount
                warning
                title="72 A 96 HORAS"
                count={ props.orders_96_72h }
              />
            </div>
          </div>
        </Card>
      </Page>
    </AppProvider>
  )
};

const OrderCount = ({ title, count, warning }) => (
  <div 
    style={{
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#c2c2c2",
    }}
    className="flex flexColumn flex1 flexContainer">
    <div
      className="p20" 
      style={{
        backgroundColor: "black",
        color: "white"
    }}>
      <DisplayText size="medium">
        { title }
      </DisplayText>
    </div>
    <div 
      style={{
        color: warning ? "#FF0100" : "#212b36"
      }}
      className="p20 pv40">
      <DisplayText size="extraLarge">
        { count }
      </DisplayText>
    </div>
  </div>
)

OrdersCounter.propTypes = propTypes;
OrdersCounter.defaultProps = defaultProps;

export default OrdersCounter;